function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M204.545 90.9091L218.75 59.6591L250 45.4545L218.75 31.25L204.545 0L190.341 31.25L159.091 45.4545L190.341 59.6591L204.545 90.9091ZM119.318 96.5909L90.9091 34.0909L62.5 96.5909L0 125L62.5 153.409L90.9091 215.909L119.318 153.409L181.818 125L119.318 96.5909ZM204.545 159.091L190.341 190.341L159.091 204.545L190.341 218.75L204.545 250L218.75 218.75L250 204.545L218.75 190.341L204.545 159.091Z",
    fill: "white",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.545 90.9091L218.75 59.6591L250 45.4545L218.75 31.25L204.545 0L190.341 31.25L159.091 45.4545L190.341 59.6591L204.545 90.9091ZM119.318 96.5909L90.9091 34.0909L62.5 96.5909L0 125L62.5 153.409L90.9091 215.909L119.318 153.409L181.818 125L119.318 96.5909ZM204.545 159.091L190.341 190.341L159.091 204.545L190.341 218.75L204.545 250L218.75 218.75L250 204.545L218.75 190.341L204.545 159.091Z",
    fill: "white",
    fillOpacity: 0.7,
    style: {
      mixBlendMode: "overlay"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector3);
export default __webpack_public_path__ + "static/media/Vector (3).77b23b1ea57bca214d0d88e22426a5a0.svg";
export { ForwardRef as ReactComponent };